"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Table;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _context = require("./context");
var _TableHead = _interopRequireDefault(require("./TableHead"));
var _TableList = _interopRequireDefault(require("./TableList"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)({
  virtualized: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%'
  }
});
function Table(_ref) {
  var _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? {
      root: null,
      tableHead: null,
      tableHeadCell: null,
      tableHeadCellAction: null,
      tableHeadRow: null,
      tableList: null,
      tableListCell: null,
      tableListCellItem: null,
      tableListCellItemLabel: null,
      tableListRow: null,
      tableListRowExpandable: null,
      tableListRowItem: null
    } : _ref$classes,
    collectionPath = _ref.collectionPath,
    _ref$dense = _ref.dense,
    dense = _ref$dense === void 0 ? false : _ref$dense,
    _ref$disableHover = _ref.disableHover,
    disableHover = _ref$disableHover === void 0 ? false : _ref$disableHover,
    expandMultiple = _ref.expandMultiple,
    fields = _ref.fields,
    getLink = _ref.getLink,
    getTableRowItemKey = _ref.getTableRowItemKey,
    headerBgColorDefault = _ref.headerBgColorDefault,
    id = _ref.id,
    itemKeyField = _ref.itemKeyField,
    items = _ref.items,
    moveListItem = _ref.moveListItem,
    translationKeyRoot = _ref.translationKeyRoot,
    reorderable = _ref.reorderable,
    search = _ref.search,
    _ref$sorting = _ref.sorting,
    sorting = _ref$sorting === void 0 ? true : _ref$sorting,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? true : _ref$sticky,
    _ref$virtualized = _ref.virtualized,
    virtualized = _ref$virtualized === void 0 ? false : _ref$virtualized;
  var styles = useStyles();
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    expandedFields = _useState2[0],
    setExpandedFields = _useState2[1];
  var expandableField = fields.find(function (field) {
    return field.type === 'expandable';
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, virtualized && styles.virtualized)
  }, /*#__PURE__*/_react.default.createElement(_context.TableHeadContext.Provider, {
    value: {
      classes: {
        tableHead: classes.tableHead,
        tableHeadCell: classes.tableHeadCell,
        tableHeadCellAction: classes.tableHeadCellAction,
        tableHeadRow: classes.tableHeadRow
      },
      dense,
      expandableField,
      fields,
      headerBgColorDefault,
      reorderable,
      search,
      sorting,
      sticky,
      translationKeyRoot,
      virtualized
    }
  }, /*#__PURE__*/_react.default.createElement(_TableHead.default, {
    id: "".concat(id, "Head")
  })), /*#__PURE__*/_react.default.createElement(_context.TableListContext.Provider, {
    value: {
      classes: {
        tableList: classes.tableList,
        tableListCell: classes.tableListCell,
        tableListCellItem: classes.tableListCellItem,
        tableListCellItemLabel: classes.tableListCellItemLabel,
        tableListRow: classes.tableListRow,
        tableListRowExpandable: classes.tableListRowExpandable,
        tableListRowItem: classes.tableListRowItem
      },
      collectionPath,
      dense,
      disableHover,
      expandableField,
      expandedFields,
      expandMultiple,
      fields,
      getLink,
      getTableRowItemKey,
      headerBgColorDefault,
      itemKeyField,
      items,
      moveListItem,
      reorderable,
      setExpandedFields
    }
  }, /*#__PURE__*/_react.default.createElement(_TableList.default, {
    id: "".concat(id, "List"),
    virtualized: virtualized
  })));
}
Table.propTypes = {
  collectionPath: _propTypes.default.string,
  fields: _propTypes.default.arrayOf(_propTypes.default.object),
  search: _propTypes.default.shape({
    orderBy: _propTypes.default.string
  })
};
Table.defaultProps = {
  collectionPath: '',
  fields: [],
  search: {
    orderBy: ''
  }
};